import Twemoji from "../../../Twemoji";
import NoteCreatedAt from "../../notebook/note/NoteCreatedAt";

export function SelectedNoteCard({ note }) {
  return (
    <div className="text-sm border p-2 rounded-standard border-secondary bg-secondary my-1">
      <div className="flex items-center gap-1">
        <Twemoji emoji={"📝"} />
        <span className="font-medium shrink-0">
          {note?.patient?.name || ""}
        </span>
        <span className="font-medium truncate min-w-0 flex-1">
          {note?.title || "Untitled Note"}
        </span>
      </div>
      <NoteCreatedAt createdAt={note?.createdAt} size="sm" />
    </div>
  );
}
